import React from 'react';
import { ShoppingCart, ShieldCheck, CreditCard } from 'lucide-react';
import { useMetaPixel } from '../hooks/useMetaPixel';
export const PricingSection: React.FC = () => {
  const {
    trackCustom
  } = useMetaPixel();
  const handleBuyClick = () => {
    trackCustom('PurchaseClick', {
      value: 19.97,
      currency: 'USD'
    });
    window.location.href = 'Link de tu checkout';
  };
  return <section id="checkout" className="py-20 bg-gradient-to-b from-white to-orange-50" data-id="element-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-orange-100" data-id="element-52">
          <div className="bg-orange-600 py-4 px-6 sm:px-10" data-id="element-53">
            <h2 className="text-2xl font-bold text-white text-center" data-id="element-54">
              Accedé hoy con precio promocional
            </h2>
          </div>

          <div className="p-8 sm:p-12 text-center" data-id="element-55">
            <p className="text-gray-500 mb-6" data-id="element-56">
              Esta promoción puede finalizar en cualquier momento.
            </p>

            <div className="flex justify-center items-baseline mb-8" data-id="element-57">
              <span className="text-2xl text-gray-400 line-through mr-4" data-id="element-58">
                $67.00
              </span>
              <span className="text-6xl font-extrabold text-gray-900" data-id="element-59">
                $19.97
              </span>
              <span className="text-xl text-gray-500 ml-2" data-id="element-60">USD</span>
            </div>

            <button onClick={handleBuyClick} className="w-full sm:w-auto bg-green-600 text-white font-bold text-xl py-5 px-10 rounded-full shadow-lg hover:bg-green-700 transform transition hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-300 flex items-center justify-center mx-auto" data-id="element-61">
              <ShoppingCart className="mr-2 h-6 w-6" data-id="element-62" />
              Acceder al MegaPack Música con descuento
            </button>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-600 max-w-lg mx-auto" data-id="element-63">
              <div className="flex items-center justify-center sm:justify-start" data-id="element-64">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-65" />
                Acceso inmediato
              </div>
              <div className="flex items-center justify-center sm:justify-start" data-id="element-66">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-67" />
                Descarga digital
              </div>
              <div className="flex items-center justify-center sm:justify-start" data-id="element-68">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-69" />
                Material imprimible
              </div>
              <div className="flex items-center justify-center sm:justify-start" data-id="element-70">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-71" />
                Bonos incluidos
              </div>
            </div>

            <div className="mt-10 pt-8 border-t border-gray-100" data-id="element-72">
              <div className="flex flex-col items-center" data-id="element-73">
                <div className="flex items-center mb-4" data-id="element-74">
                  <ShieldCheck className="h-8 w-8 text-gray-400 mr-2" data-id="element-75" />
                  <span className="font-semibold text-gray-600" data-id="element-76">
                    Garantía de satisfacción
                  </span>
                </div>
                <p className="text-gray-500 text-sm max-w-md mx-auto" data-id="element-77">
                  Tenés garantía de 7 o 14 días (editable). Si descargás el pack
                  y sentís que no te sirve para tu realidad docente, pedís el
                  reembolso dentro del plazo y listo. Sin vueltas.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-6 py-4 flex justify-center items-center space-x-4" data-id="element-78">
            <CreditCard className="h-6 w-6 text-gray-400" data-id="element-79" />
            <span className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-80">
              Pago seguro encriptado
            </span>
          </div>
        </div>
      </div>
    </section>;
};
function CheckCircleIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-81">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-82" />
    </svg>;
}